import { etWallToUtc, minuteKey } from '../nq-scalper/signals';

const ET = 'America/New_York';

interface Parts {
  year: number;
  month: number;
  day: number;
  minutes: number;
}

// One formatter, and one answer per minute. Building a formatter per bar
// froze the chart for several seconds on every recompute.
const etFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: ET,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

const partCache = new Map<number, Parts>();

function parts(ms: number): Parts {
  const minute = Math.floor(ms / 60_000);
  const cached = partCache.get(minute);
  if (cached) return cached;
  const bag: Record<string, string> = {};
  for (const part of etFormatter.formatToParts(new Date(ms))) {
    if (part.type !== 'literal') bag[part.type] = part.value;
  }
  let hour = Number(bag.hour);
  if (hour === 24) hour = 0;
  const clock: Parts = {
    year: Number(bag.year),
    month: Number(bag.month),
    day: Number(bag.day),
    minutes: hour * 60 + Number(bag.minute),
  };
  if (partCache.size > 100_000) partCache.clear();
  partCache.set(minute, clock);
  return clock;
}

/** 09:30 inclusive through 15:59 ET. */
export function isRth(ms: number): boolean {
  const clock = parts(ms).minutes;
  return clock >= 9 * 60 + 30 && clock < 16 * 60;
}

function sessionOpen(ms: number): number {
  const clock = parts(ms);
  return etWallToUtc(clock.year, clock.month, clock.day, 9, 30);
}

/** Start of the 15-minute cash bar that contains `ms`, or null outside RTH. */
export function bucket15(ms: number): number | null {
  if (!isRth(ms)) return null;
  const open = sessionOpen(ms);
  const steps = Math.floor((minuteKey(ms) - open) / (15 * 60_000));
  return open + steps * 15 * 60_000;
}

const SIXTY_FIVE = 65 * 60_000;

/** Start of the 65-minute cash bar that contains `ms`, or null outside RTH. */
export function bucket65(ms: number): number | null {
  if (!isRth(ms)) return null;
  const open = sessionOpen(ms);
  const steps = Math.floor((minuteKey(ms) - open) / SIXTY_FIVE);
  if (steps < 0 || steps > 5) return null;
  return open + steps * SIXTY_FIVE;
}
